
import { defineComponent, computed } from 'vue'
import { useRoute } from 'vue-router'
import PageHeader from '@/components/PageHeader.vue'
import useSessions from '@/composables/useSessions'
import PaymentConfirmation from '@/components/PaymentConfirmation.vue'
import useBasket from '@/composables/useBasket'

export default defineComponent({
  components: {
    PageHeader,
    PaymentConfirmation
  },
  props: {
    basketId: {
      type: String,
      required: true
    }
  },
  setup () {
    const route = useRoute()
    const { isLoggedIn } = useSessions()
    const { clearPaidBasket } = useBasket()
    // Issued with the payment and carried here in the query, because the basket
    // GUID in the path names a basket, not a booking.
    const bookingRef = typeof route.query.ref === 'string' ? route.query.ref : ''
    const loggedBody =
      'Your travelpass has been sent to your email and is also available in your account.'
    const notLoggedBody = 'Your travelpass has been sent to your email.'
    const body = computed(() => isLoggedIn.value ? loggedBody : notLoggedBody)

    clearPaidBasket()

    return {
      body,
      bookingRef
    }
  }
})
